import React from 'react'
import { SOCKET_URL } from '../../../core/constants/urls'
import { usePredictContext } from '../context/PredictContextProvider'

const PairImg = ({ ticker, size = 30 }) => {

    const { assistant } = usePredictContext()

    return (
        <div className={`relative`}>
            <img
                src={SOCKET_URL + `assets/icon/${ticker.toUpperCase()}.png`}
                width={size + 10}
                height={size + 10}
                alt={ticker}
            />
        </div>
    )
}

export default PairImg